module.exports = __webpack_public_path__ + "static/media/comp-drying-s.2e51d16c.webp";